import email from "../assets/email.png";
import mobile from "../assets/mobile.png";
import api from "../assets/api.png";
import cpp from "../assets/cpp.png";
import css from "../assets/css.png";
import figma from "../assets/figma.png";
import flutter from "../assets/flutter.png";
import git from "../assets/git.png";
import graphql from "../assets/graphql.png";
import html from "../assets/html.png";
import javascript from "../assets/javascript.png";
import mu5 from "../assets/mu5.png";
import node from "../assets/node.png";
import python from "../assets/python.png";
import react from "../assets/react.png";
import redux from "../assets/redux.png";
import sass from "../assets/sass.png";
import typescript from "../assets/typescript.png";
import vue from "../assets/vue.png";

import about01 from "../assets/about01.png";
import about02 from "../assets/about02.png";
import about03 from "../assets/about03.png";
import about04 from "../assets/about04.png";

import profile from "../assets/profile.jpg";
import circle from "../assets/circle.svg";
import logo from "../assets/logo.png";

import adidas from "../assets/adidas.png";
import amazon from "../assets/amazon.png";
import asus from "../assets/asus.png";
import bolt from "../assets/bolt.png";
import nb from "../assets/nb.png";
import aws1 from "../assets/aws1.png";
import aws2 from "../assets/aws2.png";
import kube from "../assets/kube.png";
import skype from "../assets/skype.png";
import spotify from "../assets/spotify.png";
import people01 from "../assets/people01.jpeg";
import people02 from "../assets/people02.jpg";
import people03 from "../assets/people03.jpeg";
import people04 from "../assets/people04.jpg";
import name01 from "../assets/name01.png";
import work1 from "../assets/myWorkfitness.png";
import work2 from "../assets/myWorkmovie.png";
import work3 from "../assets/myWorkPage1.png";
import work4 from "../assets/myWorkPage2.png";
import work5 from "../assets/myWorkshooping.png";
import work6 from "../assets/myWorkshooping1.png";
import work7 from "../assets/myStockApp.png";
import work8 from "../assets/myblogapp.png";
import work9 from "../assets/netflix.png";
import work10 from "../assets/car.png";
import work11 from "../assets/filmpire.png";
import work12 from "../assets/devflow.png";
import work13 from "../assets/voyager.png";
import work14 from "../assets/thread.png";
import work15 from "../assets/evently.png";
import work16 from "../assets/questionary.png";
import work17 from "../assets/messenger.png";
import work18 from "../assets/ecommerce.png";
import work19 from "../assets/paypal.png";
import work20 from "../assets/cloud.png";
import work21 from "../assets/capstone.jpg";
export default {
  work1,
  work2,
  work3,
  work4,
  work5,
  work6,
  work7,
  work8,
  work9,
  work10,
  work11,
  work12,
  work13,
  work14,
  work15,
  work16,
  work17,
  work18,
  work19,
  work20,
  work21,
  name01,
  people01,
  people02,
  people03,
  people04,
  email,
  mobile,
  aws1,
  aws2,
  kube,
  api,
  cpp,
  css,
  figma,
  flutter,
  git,
  graphql,
  html,
  javascript,
  mu5,
  node,
  python,
  react,
  redux,
  sass,
  typescript,
  vue,
  about01,
  about02,
  about03,
  about04,
  profile,
  circle,
  logo,
  adidas,
  amazon,
  asus,
  bolt,
  nb,
  skype,
  spotify,
};
